import { cn } from "../../lib/utils";

interface EscapeHatchesProps {
  visible: boolean;
  onSkip: () => void;
  onReset: () => void;
  onHelp: () => void;
}

export function EscapeHatches({
  visible,
  onSkip,
  onReset,
  onHelp,
}: EscapeHatchesProps) {
  if (!visible) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 border-t border-border bg-secondary/30">
      <span className="text-xs text-muted-foreground mr-2">Stuck?</span>
      
      <button
        onClick={onSkip}
        className={cn(
          "inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-xs font-medium",
          "bg-secondary text-secondary-foreground",
          "hover:bg-secondary/80 active:scale-98",
          "transition-all duration-150"
        )}
      >
        Skip
        <svg className="size-3" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      <button
        onClick={onReset}
        className={cn(
          "inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-xs font-medium",
          "text-muted-foreground",
          "hover:bg-secondary hover:text-secondary-foreground active:scale-98",
          "transition-all duration-150"
        )}
      >
        <svg className="size-3" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M15.312 11.424a5.5 5.5 0 01-9.201 2.466l-.312-.311h2.433a.75.75 0 000-1.5H3.989a.75.75 0 00-.75.75v4.242a.75.75 0 001.5 0v-2.43l.31.31a7 7 0 0011.712-3.138.75.75 0 00-1.449-.39zm1.23-3.723a.75.75 0 00.219-.53V2.929a.75.75 0 00-1.5 0V5.36l-.31-.31A7 7 0 003.239 8.188a.75.75 0 101.448.389A5.5 5.5 0 0113.89 6.11l.311.31h-2.432a.75.75 0 000 1.5h4.243a.75.75 0 00.53-.219z"
            clipRule="evenodd"
          />
        </svg>
        Start over
      </button>

      <button
        onClick={onHelp}
        className={cn(
          "inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-xs font-medium",
          "text-muted-foreground",
          "hover:bg-secondary hover:text-secondary-foreground active:scale-98",
          "transition-all duration-150"
        )}
      >
        <svg className="size-3" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
          />
        </svg>
        Help
      </button>
    </div>
  );
}



